import React from 'react'
import styled from 'styled-components'

/** propsのtype定義 */
export type FrameStyle = {
  background?: string
  border?: string
  margin?: string
  padding?: string
}

/** 枠表示コンポーネントのtype定義 */
export type Props = FrameStyle & {
  children: React.ReactNode
}

/**
 * 枠表示コンポーネント
 * @param props FrameStyle
 * @returns
 */
export const Frame: React.FC<Props> = (props) => {
  const { children } = props
  return <StyledFrame {...props}>{children}</StyledFrame>
}

/** 枠表示用コンポーネントのスタイル定義 */
const StyledFrame = styled.div<FrameStyle>`
  margin: ${(props: FrameStyle): string => props.margin || '5px'};
  padding: ${(props: FrameStyle): string => props.padding || '5px'};
  background-color: ${(props: FrameStyle): string =>
    props.background || `var('--color-content-background')`};
  border: ${(props: FrameStyle): string => props.border || 'solid 2px black'};
`
